import { createFileRoute } from '@tanstack/react-router';

import { createCatchAllRouteGuard } from '@/utils/route-guards/catch-all-guard';

export const Route = createFileRoute('/$org/$agent/$')({
  beforeLoad: createCatchAllRouteGuard(),
});
